module.exports = __webpack_public_path__ + "4ede7064e2caca463210a152a643650b.pdf";